export default {
  // mono
  black: "#2f353a",
  blackDark: "rgba(0, 0, 0, .35)",
  blackGradient: "radial-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.6))",
  blackGradientDark: "radial-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.8))",

  blueGray: "#5c6873",
  grayDark: "#e4e5e6",
  gray: "#c8ced3",
  grayLight: "#f0f3f5",
  inputBorder: "#e4e7ea",

  white: "#fff",

  // basic
  transparent: "transparent",
  blue: "#20a8d8",
  blueDark: "#1b8eb8",
  redDark: "#ED0C0C",
  red: "#f86c6b",
  redLight: "#FDE6E6",
  yellowDark: "#9E7600",
  yellow: "#ffc107",
  yellowLight: "#FFF8E5",
  green: "#4dbd74",
  greenLight: "#b5f5ca",
  purple: "#6f42c1",

  // sns
  twitter: "#1DA1F2",
  facebook: "#4267B2",
  instagram: "",

  // google
  googleBlue: "#5190F9",

  // other
  typoLight: "#73818f",
};
